export enum INBOX_SEND_MESSAGE_STATUS_CODE {
    OK = 'OK'
}
